import { Link } from "react-router-dom";

/** Switches between the quote form and the free sample variant on /quote. */
export function QuoteTabs({ active }: { active: "quote" | "sample" }) {
  return (
    <nav className="t-quote-tabs" aria-label="Request type">
      <Link to="/quote" aria-current={active === "quote" ? "page" : undefined}>Paid quote</Link>
      <Link to="/quote?type=sample" aria-current={active === "sample" ? "page" : undefined}>Free sample</Link>
    </nav>
  );
}
